import { actions } from 'react-table';
import type { ActionType } from 'react-table';

const FILTER_ACTION_TYPES = new Set([
  actions.setFilter,
  actions.setAllFilters,
  actions.resetFilters,
  actions.setGlobalFilter,
  actions.resetGlobalFilter,
]);

/**
 * React Table state reducer that keeps pagination stable for every action except
 * an explicit column or global-filter update.
 */
export const resetPageIndexOnFilterAction = <
  State extends { pageIndex: number },
>(
  newState: State,
  action: Pick<ActionType, 'type'>
): State => {
  if (newState.pageIndex === 0 || !FILTER_ACTION_TYPES.has(action.type)) {
    return newState;
  }

  return { ...newState, pageIndex: 0 };
};
